<template>
  <div class="flex mt-2 gap-1 items-center">
    <TIcon class="inline" color="nash-fern600" icon="checkCircle" />
    Your feedback has been submitted.
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: { TIcon },
})
</script>
